import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import allProducts from "../assets/data/processedProducts";
import imageMap from "../assets/data/imageMap";
import fallbackImage from "../assets/images/fallback.jpg";

const ProductDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const product = allProducts.find((p) => String(p.ID) === id);

  const [selectedColour, setSelectedColour] = useState(
    product?.ColourVariants?.[0] || null
  );

  if (!product) {
    return (
      <div className="text-center py-20 text-red-500 text-lg pt-20">
        Product not found
      </div>
    );
  }

  const accessoryVariants =
    product.Category === "Accessories"
      ? allProducts.filter(
          (p) =>
            p.Category === "Accessories" &&
            p.Series === product.Series
        )
      : [];

  const imageFile =
    selectedColour
      ? `${product.ImageBase} ${selectedColour.toUpperCase()}.webp`
      : product.Image;

  const imageSrc = imageMap[imageFile] || fallbackImage;

  return (
    <div className="max-w-4xl mx-auto p-6 pt-20">
      <button
        className="mb-4 text-blue-600 hover:underline"
        onClick={() => navigate(-1)}
      >
        ← Go Back
      </button>

      <div className="grid md:grid-cols-2 gap-6 items-start">
        <img
          src={imageSrc}
          alt={product.Item}
          className="rounded-lg shadow w-full"
        />

        <div>
          <h2 className="text-3xl font-bold mb-2 text-blue-800">
            {product.Category === "Accessories"
              ? product.Series
              : product.Item}
          </h2>

          {product.Description && (
            <p className="mb-4 text-gray-700">
              {product.Description}
            </p>
          )}

          {/* TAPS ONLY */}
          {product.Category !== "Accessories" && product.Series && (
            <div className="mb-2">
              <span className="font-semibold">Series:</span>{" "}
              <Link
                to={`/products/taps?series=${product.Series}`}
                className="text-blue-600 hover:underline"
              >
                {product.Series}
              </Link>
            </div>
          )}

          {/* TAPS ONLY */}
          {product.Category !== "Accessories" && product.Type && (
            <div className="mb-4">
              <span className="font-semibold">Type:</span>{" "}
              <Link
                to={`/products/taps?type=${product.Type}`}
                className="text-blue-600 hover:underline"
              >
                {product.Type}
              </Link>
            </div>
          )}

          {/* ACCESSORY VARIANTS */}
          {product.Category === "Accessories" &&
            accessoryVariants.length > 1 && (
              <div className="mb-6">
                <h3 className="font-semibold mb-2">
                  Available Options
                </h3>

                <div className="overflow-hidden border rounded-lg">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="text-left p-2">
                          Variant
                        </th>
                        <th className="text-left p-2">
                          Code
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {accessoryVariants.map((variant) => (
                        <tr
                          key={variant.ID}
                          className="border-t"
                        >
                          <td className="p-2">
                            {variant.Type.replace(
                              product.Series,
                              ""
                            ).trim()}
                          </td>

                          <td className="p-2 font-medium">
                            {variant.Item}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

          {/* MATERIAL */}
          {product.Material && (
            <div className="mb-4">
              <span className="font-semibold">Material:</span>{" "}
              <span className="text-gray-700">
                {product.Material}
              </span>
            </div>
          )}

          {/* COLOUR OPTIONS - TAPS ONLY */}
          {product.ColourVariants?.length > 0 && (
            <div className="mb-4">
              <span className="font-semibold">Colour:</span>

              <div className="flex gap-2 mt-2 flex-wrap">
                {product.ColourVariants.map((colour) => (
                  <button
                    key={colour}
                    onClick={() => setSelectedColour(colour)}
                    className={`px-3 py-1 border rounded ${
                      selectedColour === colour
                        ? "bg-[#1E3A66] text-white border-[#1E3A66]"
                        : "bg-white text-gray-700"
                    }`}
                  >
                    {colour.charAt(0).toUpperCase() +
                      colour.slice(1)}
                  </button>
                ))}
              </div>
            </div>
          )}


        </div>
      </div>
    </div>
  );
};

export default ProductDetailPage;